import { Injectable } from '@angular/core';
import { AnecdotalApi } from 'src/app/api/observations/anecdotal.api';
import { CreateObservationDTO } from 'src/app/model/observation/diff/diff-create-dto.model';

@Injectable()
export class AnecdotalObservationService {
    constructor(private anecdotalApi: AnecdotalApi) { }

    getObservationDetails = (userId: string, observationId: string) =>
        this.anecdotalApi.getObservationDetails(userId, observationId);

    createAnecdotal = (observation: CreateObservationDTO) =>
        this.anecdotalApi.createAnecdotal(observation);

    submitAnecdotal = (observationId: string) =>
        this.anecdotalApi.submitAnecdotal(observationId);
}
